module.exports = __webpack_public_path__ + "static/img/klab-edu-logo.aa195b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/klab-edu-logo.svg
// module id = xqfE
// module chunks = 0